import { plainToInstanceWithLVS } from '@goparrot/common';
import { BaseCampaignFacade } from '../../common';
import { ReadCampaignDto } from '../generated-dto';
import { CampaignExposeGroup } from '../interface';
export class CampaignFacade extends BaseCampaignFacade {
    async getList(merchantId) {
        const result = await this.client.get(`api/v2/merchants/${merchantId}/campaigns`);
        return plainToInstanceWithLVS(ReadCampaignDto, result.data, {
            groups: [CampaignExposeGroup.READ],
        });
    }
    async get(merchantId, id) {
        return plainToInstanceWithLVS(ReadCampaignDto, (await this.client.get(`api/v2/merchants/${merchantId}/campaigns/${id}`)).data, {
            groups: [CampaignExposeGroup.READ],
        });
    }
    async create(merchantId, data) {
        return plainToInstanceWithLVS(ReadCampaignDto, (await this.client.post(`/api/v2/merchants/${merchantId}/campaigns`, data)).data, {
            groups: [CampaignExposeGroup.READ],
        });
    }
    async update(merchantId, id, data) {
        return plainToInstanceWithLVS(ReadCampaignDto, (await this.client.patch(`/api/v2/merchants/${merchantId}/campaigns/${id}`, data)).data, {
            groups: [CampaignExposeGroup.READ],
        });
    }
    async validate(merchantId, id) {
        return plainToInstanceWithLVS(ReadCampaignDto, (await this.client.patch(`/api/v2/merchants/${merchantId}/campaigns/${id}/validate`)).data, {
            groups: [CampaignExposeGroup.READ],
        });
    }
    async start(merchantId, id) {
        return plainToInstanceWithLVS(ReadCampaignDto, (await this.client.patch(`/api/v2/merchants/${merchantId}/campaigns/${id}/start`)).data, {
            groups: [CampaignExposeGroup.READ],
        });
    }
    async complete(merchantId, id) {
        return plainToInstanceWithLVS(ReadCampaignDto, (await this.client.patch(`/api/v2/merchants/${merchantId}/campaigns/${id}/complete`)).data, {
            groups: [CampaignExposeGroup.READ],
        });
    }
    async delete(merchantId, id) {
        await this.client.delete(`api/v2/merchants/${merchantId}/campaigns/${id}`);
    }
}
//# sourceMappingURL=CampaignFacade.js.map